/**
 * The name to show customers for the active storefront.
 *
 * Always use this instead of `config.name`. `name` is the raw menu-link field,
 * which the dashboard has historically presented as an internal label ("Link
 * Name"), so a large share of real tenants carry a default there — `"Default"`
 * from tenant mint, or a link-type label like `"Online Ordering"`. Tenant 168
 * (burgerinboxeg.com) is the live example: its storefront title read
 * "Online Ordering — Online Ordering" and the installed PWA was "Online Order".
 *
 * `displayName` is resolved server-side (menu link name, else brand name) by
 * `online_ordering_service/app/services/storefront_name.py`. The `name` fallback
 * here only covers a storefront running against an older API build.
 */
import type { OnlineOrderingConfig } from "@/api/online-ordering-service/model";

export function storefrontName(
  config: Pick<OnlineOrderingConfig, "name"> &
    { displayName?: string | null } | null | undefined,
  fallback = "Online Ordering",
): string {
  return (
    config?.displayName?.trim() || config?.name?.trim() || fallback
  );
}
